export const FETCH_SHOP = "FETCH_SHOP";
export const LOADING_SHOP = "LOADING_SHOP";
export const FETCH_SHOP_PRODUCT = "FETCH_SHOP_PRODUCT";
export const FETCH_SHOP_TYPE = "FETCH_SHOP_TYPE";
export const FETCH_TRACKING_SALE = "FETCH_TRACKING_SALE";
export const LOADING_PRODUCT_BUTTONS = "LOADING_PRODUCT_BUTTONS";
export const FETCH_MY_ORDERS = "FETCH_MY_ORDERS";
export const SET_LOGIN = "SET_LOGIN";
export const RESET_SHOP = "RESET_SHOP";

export const ADD_CART = "ADD_CART";
export const FETCH_CART = "FETCH_CART";
export const DELETE_ITEM_CART = "DELETE_ITEM_CART";
export const UPDATE_CART = "UPDATE_CART";
export const FETCH_CLIENT = "FETCH_CLIENT";
export const CHECKOUT_CART = "CHECKOUT_CART";
export const LOADING_CART = "LOADING_CART";
export const EXTEND_CART_SESSION = "EXTEND_CART_SESSION";
export const RESET_ALERT_MESSAGE_CART = "RESET_ALERT_MESSAGE_CART";
export const FETCH_SHIPPING_COST = "FETCH_SHIPPING_COST";
export const RESET_SHIPPING_COST = "RESET_SHIPPING_COST";
export const RESET_CLIENT = "RESET_CLIENT";

export interface Product {
  id: number;
  code: number;
  cost: number;
  name: string;
  path: string;
  price: number;
  price_wholesale: number;
  description: string;
  types: Type[] | [];
  cantCart: number;
  rowId: string;
  stock: number;
}

export interface Type {
  id: number;
  name: string;
  path: string;
  pivot: {
    product_id: number;
  };
}

export interface Cart {
  id: number;
  name: string;
  options: {
    img: string;
    shoppingCartId: number;
    updated_at: string;
    product: Product;
  };
  price: number;
  qty: number;
  rowId: string;
}

//Shop

export interface ShopState {
  product_types: Type[];
  products: any[];
  product: any;
  typesSizes: any;
  pathImages: any;
  isDisabledSite: boolean;
  isLoading: boolean;
  textPages: any;
  trackingSale: any;
  isLoadingProductButtons: boolean;
  myOrders: any[];
  isLogued: boolean;
  lastPage: boolean;
}

interface FetchShopAction {
  type: typeof FETCH_SHOP;
  payload: {
    product_types: Type[];
    isDisabledSite: boolean;
    text_pages: any;
  };
}

interface LoadingShopAction {
  type: typeof LOADING_SHOP;
}

interface ResetShopAction {
  type: typeof RESET_SHOP;
}

interface LoadingProductButtonsAction {
  type: typeof LOADING_PRODUCT_BUTTONS;
}

interface FetchShopProductAction {
  type: typeof FETCH_SHOP_PRODUCT;
  payload: { product: Product; pathImages: string[]; typesSizes: Type[] };
}

interface FetchShopTypeAction {
  type: typeof FETCH_SHOP_TYPE;
  payload: {
    page: number;
    products: Product[];
    last_page: boolean;
  };
}

interface FetchTrackingSale {
  type: typeof FETCH_TRACKING_SALE;
  payload: any;
}

//Cart

export interface CartState {
  cart: Cart[] | [];
  totalCart: number;
  itemsCart: number;
  minimumCart: number;
  alertMessage: string | null;
  payways: { id: number; name: string }[] | null;
  client: {} | null;
  addressPickup: string | null;
  incrementSale: number;
  messageFinish: string | null;
  frequentUserCoupon: string | null;
  isLoading: boolean;
  provinces: any[];
  shippingCost: number;
}

interface FetchCart {
  cart: Cart[];
  totalCart: number;
  itemsCart: number;
  minimumCart: number;
  frequentUserCoupon: string | null;
}

export interface CheckoutData {
  user_id: number;
  post: string;
  wholesale: number;
  invoice_type_id: number;
  client_id: number;
  cell_phone: string;
  name: string;
  document_number: string;
  email: string;
  last_name: string;
  address: string;
  city: string;
  postal_code: string;
  province: number;
  local_pickup: number;
  payway_id: number;
  increase1: number;
  totalCart: number;
  subTotalCart: number;
  shippingCost: number;
}

export interface FetchClientData {
  cell_phone: string;
  client_id: string | null;
}

interface FetchCartAction {
  type: typeof FETCH_CART;
  payload: FetchCart;
}

interface AddCartAction {
  type: typeof ADD_CART;
  payload: FetchCart & { alertMessage: string };
}

interface DeleteCartAction {
  type: typeof DELETE_ITEM_CART;
  payload: FetchCart;
}

interface UpdateCartAction {
  type: typeof UPDATE_CART;
  payload: FetchCart & { alertMessage: string };
}

interface FetchClientCartAction {
  type: typeof FETCH_CLIENT;
  payload: any;
}

interface FetchShippingCostAction {
  type: typeof FETCH_SHIPPING_COST;
  payload: any;
}

interface ResetShippingCostAction {
  type: typeof RESET_SHIPPING_COST;
}

interface CheckOutCartAction {
  type: typeof CHECKOUT_CART;
  payload: any;
}

interface LoadingCartAction {
  type: typeof LOADING_CART;
}

interface ExtendSessionCartAction {
  type: typeof EXTEND_CART_SESSION;
}

interface ResetAlertMessageCart {
  type: typeof RESET_ALERT_MESSAGE_CART;
}

interface ResetClientCart {
  type: typeof RESET_CLIENT;
}

interface FetchMyOrdersAction {
  type: typeof FETCH_MY_ORDERS;
  payload: any;
}

interface SetLoginAction {
  type: typeof SET_LOGIN;
  payload: any;
}

export type ShopActionTypes =
  | FetchShopAction
  | LoadingShopAction
  | FetchShopProductAction
  | FetchShopTypeAction
  | FetchTrackingSale
  | LoadingProductButtonsAction
  | FetchMyOrdersAction
  | SetLoginAction
  | ResetShopAction;

export type CartActionTypes =
  | FetchCartAction
  | AddCartAction
  | DeleteCartAction
  | UpdateCartAction
  | FetchClientCartAction
  | CheckOutCartAction
  | LoadingCartAction
  | ExtendSessionCartAction
  | ResetAlertMessageCart
  | FetchShippingCostAction
  | ResetShippingCostAction
  | ResetClientCart;
